import { string } from "yup";
import { validationMessages } from "utils/yup/validationMessages";

import { IEReservationQueueFormField } from "../types/IEReservationQueueFormField";
import { FieldType } from "../types/FieldType";

export const fieldValidationSchemaGenerator = (
  field: IEReservationQueueFormField
) => {
  switch (field.fieldType) {
    case FieldType.TextField:
      return field.required
        ? string().required(validationMessages.requiredField)
        : string();
    case FieldType.PhoneField:
      return field.required
        ? string().required(validationMessages.requiredField)
        : string();
    case FieldType.TextArea:
      return field.required
        ? string().required(validationMessages.requiredField)
        : string();
    default:
      return string();
  }
};
